import React from "react";
import Select from "react-select";

const MultiSelectDropdown = ({ options, value, onChange }) => {
  console.log("MultiSelectDropdown options:", options); // Log the options
  console.log("MultiSelectDropdown value:", value); // Log the current value

  const formattedOptions = options.map((option) => ({
    value: option,
    label: option,
  }));

  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    console.log("MultiSelectDropdown selected values:", selectedValues); // Log the selected values
    onChange(selectedValues);
  };

  return (
    <Select
      isMulti
      options={formattedOptions}
      value={formattedOptions.filter((option) => value.includes(option.value))}
      onChange={handleChange}
    />
  );
};

export default MultiSelectDropdown;
